import React, { useEffect, useRef, useState } from 'react';
import { useReactQuery } from 'hooks/useReactQuery';
import Popup from 'components/Nav/SearchNav/Popup';
import { requestUrl } from 'config';
import { ReactComponent as SmallSearch } from 'assets/images/icon/small_search_black.svg';
import { ReactComponent as Close } from 'assets/images/icon/close.svg';
import useDebounceValue from 'hooks/useDebounce';

const { searchAll } = requestUrl;

const SearchNav = () => {
  const [isSearch, setIsSearch] = useState(false);
  const [isPopup, setIsPopup] = useState(false);
  const [userInput, setUserInput] = useState('');
  const [state, debouncedSetState] = useDebounceValue('');
  debouncedSetState(userInput);
  const inputRef = useRef(null);
  const query = `?keyword=${state}`;
  const url = `${searchAll}${query}`;
  const { isSuccess, data, isError } = useReactQuery(['search', state], url, { enabled: Boolean(state) });
  const activateSearch = () => {
    setIsSearch(true);
    inputRef.current.focus();
  };

  const closePopup = () => {
    setIsSearch(false);
    setIsPopup(false);
    debouncedSetState('');
  };

  const deactivateSearch = e => {
    closePopup();
    setUserInput('');
    debouncedSetState('');
  };

  const handleUserInput = e => {
    setUserInput(e.target.value);
    e.target.value === '' ? setIsPopup(false) : setIsPopup(true);
  };

  useEffect(() => {
    if (isSearch) return;
    debouncedSetState('');
  }, [isSearch, debouncedSetState]);

  return (
    <div className="search-bar relative padding-row-64 height-48 centered">
      <div className="input-wrapper relative">
        <div className="icon-wrapper">
          <SmallSearch onClick={activateSearch} className={`icon search absolute height-24 width-24 link${isSearch ? ' activate' : ''}`} />
        </div>
        <input
          onChange={handleUserInput}
          onBlur={() => setTimeout(closePopup, 100)}
          ref={inputRef}
          className={`user-input width-0 border-none outline-none placeholder-neutrals-1 font-16${isSearch ? ' activate' : ''}`}
          type="text"
          placeholder="Search..."
          value={userInput}
        />
        <div onClick={deactivateSearch} className={`close absolute opacity-0 link${isSearch ? ' activate' : ''}`}>
          <Close className="icon" />
        </div>
        {isSuccess && <Popup isPopup={isPopup} data={data} />}
      </div>
    </div>
  );
};

export default SearchNav;
